import { HttpRequest, HttpResponse } from '@angular/common/http'

export interface HeliosHttpRequests extends HttpRequest<unknown> {
  heliosSessionId?: string
  requestId: string
  response?: HttpResponse<unknown>
  duration?: number
  requestedAt: Date
  completedAt?: Date
}

/**
 *
 */
export function isHeliosHttpRequestDuplicate(
  a: HeliosHttpRequests,
  b: HeliosHttpRequests,
) {
  return (
    a.requestId !== b.requestId &&
    a.url === b.url &&
    a.method === b.method &&
    JSON.stringify(a.body) === JSON.stringify(b.body) && //this is request body
    ((a.response == null && b.response == null) ||
      (a.response != null &&
        b.response != null &&
        JSON.stringify(a.response.body) === JSON.stringify(b.response.body)))
  )
}
